<template>
  <div
    class="payouts-to-card-table-item"
    @click="$emit('click', payoutsRegistryItem.id)"
  >
    <div class="transaction-table-item">
      <div class="transaction-table-item__short-info">
        <div
          class="transaction-table-item__col transaction-table-item__card-number"
        >
          <text-input
            mode="small"
            mask="XXXX XXXX XXXX XXXX"
            v-model:value="payoutsRegistryItemUpdated.pan"
            :is-error="!!payoutsRegistryItem.error.pan || false"
            @textInputBlur="handleUpdatePayoutRegistryItem"
          ></text-input>
        </div>
        <div
          class="transaction-table-item__col transaction-table-item__recipient"
        >
          <text-input
            mode="small"
            v-model:value="payoutsRegistryItemUpdated.fio"
            :is-error="!!payoutsRegistryItem.error.fio || false"
            @textInputBlur="handleUpdatePayoutRegistryItem"
          ></text-input>
        </div>
        <div
          class="transaction-table-item__col transaction-table-item__recipient"
        >
          <text-input
            mode="small"
            :mask="'NNNNNNNNNN'"
            v-model:value="payoutsRegistryItemUpdated.ipn"
            :is-error="!!payoutsRegistryItem.error.ipn || false"
            @textInputBlur="handleUpdatePayoutRegistryItem"
          ></text-input>
        </div>
        <div class="transaction-table-item__col transaction-table-item__sum">
          <text-input
            :centered="true"
            mode="small"
            :mask="$options.NUMBER_MASK"
            v-model:value="payoutsRegistryItemUpdated.sum"
            :is-error="!!payoutsRegistryItem.error.sum || false"
            @textInputBlur="handleUpdatePayoutRegistryItem"
          ></text-input>
        </div>
        <div
          class="transaction-table-item__col transaction-table-item__commission"
        >
          {{ commission }}
        </div>
        <div
          class="transaction-table-item__col transaction-table-item__currency"
        >
          UAH
        </div>
        <div
          class="transaction-table-item__col transaction-table-item__currency"
        >
          <transaction-status :status-id="status"></transaction-status>
        </div>

        <div
          class="transaction-table-item__col transaction-table-item__delete"
          @click.stop="handleDeleteItem"
        >
          <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="1.47754"
              y1="10.6312"
              x2="11.1087"
              y2="1.00005"
              stroke="#64748B"
              stroke-width="2"
              stroke-linecap="round"
            />
            <line
              x1="1"
              y1="-1"
              x2="14.6205"
              y2="-1"
              transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 11.0449 12.0454)"
              stroke="#64748B"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  $on,
  $off,
  $once,
  $emit,
} from '../../../../../../utils/gogocodeTransfer'
import TransactionStatus from '@vue-app/components/transaction/TransactionStatus.vue'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import { RouteHelper } from '@js-app/services/helpers/routes/routes-helper'
import { mapState } from 'vuex'
import Loader from '@vue-app/components/base/Loader.vue'
import TransactionsTableActionsButton from '@vue-app/components/company/transactions/table/TransactionsTableActionsButton.vue'
import TextInput from '@vue-app/components/base/input/TextInput.vue'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { ERROR } from '@js-app/const/operation-statuses-ids'

export default {
  name: 'PayoutsRegistryCreatedTableItem',
  components: {
    TextInput,
    TransactionsTableActionsButton,
    Loader,
    TransactionStatus,
  },
  props: {
    payoutsRegistryItem: {
      type: Object,
    },
  },
  data() {
    return {
      isPayoutsRegistryItemUpdated: false,
      payoutsRegistryItemUpdated: {
        ...this.payoutsRegistryItem,
        sum: (parseInt(this.payoutsRegistryItem.sum) / 100).toFixed(2),
      },
    }
  },
  watch: {
    payoutsRegistryItemUpdated: {
      handler(old, _new) {
        this.isPayoutsRegistryItemUpdated = true
      },
      flush: 'post',
      deep: true,
    },
  },
  NUMBER_MASK: createNumberMask({
    prefix: '',
    allowDecimal: true,
    includeThousandsSeparator: false,
    allowNegative: false,
    decimalLimit: 2,
  }),
  computed: {
    ...mapState(['selectedCompany']),
    itemActions() {
      let _actions = []
      return _actions
    },
    commission() {
      return (
        parseInt(this.payoutsRegistryItemUpdated.commission || 0) / 100
      ).toFixed(2)
    },
    status() {
      if (this.payoutsRegistryItem.status === 'new') {
        return 0
      }
      if (this.payoutsRegistryItem.status === 'error') {
        return ERROR
      }

      return this.payoutsRegistryItem.operation_status_id
    },
  },
  methods: {
    async handleActionFired(action) {
      try {
        await action.handler()
      } catch (e) {
        console.error(e)
      }

      try {
        this.$refs.transactionItem.actionFinished(action.id)
      } catch (e) {}
    },
    async loadReceipt() {
      let receiptResponse = await CompaniesApi.getBillReceipt(
        this.selectedCompany,
        this.transaction.operationId
      )
      this.transactionReceiptBlob = URL.createObjectURL(receiptResponse.data)
      return this.$refs.transactionReceiptPopup.open()
    },
    toPayoutToCardDetails() {
      this.$router.push(
        RouteHelper.getRoute('payout-to-card-view', {
          companyId: this.selectedCompany,
          payoutId: this.transaction.operationId,
        })
      )
    },
    handleDeleteItem() {
      $emit(this, 'deleted', this.payoutsRegistryItem)
    },
    handleUpdatePayoutRegistryItem() {
      if (this.isPayoutsRegistryItemUpdated) {
        this.isPayoutsRegistryItemUpdated = false
        $emit(this, 'updated', this.payoutsRegistryItemUpdated)
      }
    },
  },
  emits: ['click', 'deleted', 'updated'],
}
</script>

<style lang="scss" scoped>
.payouts-to-card-table-item {
  .transaction-table-item {
    &__date {
      padding: 0;
    }

    &__name {
      word-break: break-all;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: #1a1f29;
      opacity: 0.7;
    }

    &__amount {
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      color: #1a1f29;
      opacity: 0.7;
      justify-content: flex-end;
    }

    &__commission {
      justify-content: center;
    }

    &__currency {
      justify-content: center;
    }

    &__delete {
      justify-content: center;
    }

    &__status {
      align-self: center;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 20px;
      padding-right: 20px;

      &-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 105px;
        max-width: 100%;
        height: 28px;
        border-radius: 6px;
        font-weight: 500;
        font-size: 12px;
        line-height: 28px;

        &--paid {
          background: rgba(39, 204, 36, 0.2);
          color: #44d941;
        }
      }
    }
  }
}
</style>
